import React from 'react'
import { Form, Input, Select, DatePicker  } from 'antd'
import Button from '../../Atoms/Button/Button'
import InputFormContainer from '../../Atoms/InputFormContainer/InputFormContainer'
import FormTitle from '../../Atoms/FormTitle/FormTitle'
import Modal from '../Modal/Modal'
import { useModal } from '../../../customHooks/useModal'
import iconSuccess from '../../../assets/iconProfileCreate.svg'
import { useLocation } from 'wouter'
import { useState } from 'react'
import SliderRangeCampaing from '../SliderRangeCampaing/SliderRangeCampaing'
const { Option } = Select;

const FormCampaing = ({ newCampaing }) => {
  const [form] = Form.useForm();
  const [, setLocation] = useLocation()
  const [typeCampaing, setTypeCampaing] = useState(null)
  const [isOpenModalSuccess, openModalSuccess, closeModalSuccess] = useModal(false)

  const sendForm = (e) => {
    console.log(e); // Aqui el objeto con los valores del formulario
    openModalSuccess()
  };

  const onChange = (e) => {
    console.log(e); 
  };

  const clearForm = () => {
    form.resetFields()
    closeModalSuccess()
  }

  return (
    <>
    <Form onFinish={sendForm} form={form} initialValues={{
        typecampaing: newCampaing ? null : 2,
        name: newCampaing ? null : 'Nombre de la campaña',
        objectives: newCampaing ? null : 'Ventas',
        actions: newCampaing ? [] : ['Contratación', 'Reserva'],
        channels: newCampaing ? [] : ['Email'],
        tags: newCampaing ? [] : ['Etiqueta 1'],
        // initDate: newCampaing ? null : 'Fecha de inicio',
        // initHour: newCampaing ? null : '10-30',
        // finalitationDate: newCampaing ? null : 'Fecha de finalización',
        // finalitationHour: newCampaing ? null : 'Hora de finalización',
        frecuence: newCampaing ? null : 'Repetir diariamente',
    }}>
      <FormTitle noSpace text="Tipo de campaña:" />

      <InputFormContainer label="Tipo de campaña:" indentificador="typecampaing" >
        <Form.Item  name="typecampaing" rules={[{required: true, message: "Por favor ingresa el tipo de campaña"}]}>
          <Select size="large" placeholder="Tipo de campaña" onChange={value => setTypeCampaing(value)}>
            <Option value={1}>Inbound</Option> 
            <Option value={2}>Outbound</Option> 
          </Select>
        </Form.Item>
      </InputFormContainer>

      <InputFormContainer label="Nombre:" indentificador="name">
        <Form.Item name="name" rules={[{ required: true, message: "Debes colocar el nombre de la campaña" }]} >
          <Input size="large" maxLength={70} placeholder="Escoge un nombre atractivo para tu campaña… (max 70 caracteres)" />
        </Form.Item>
      </InputFormContainer>

      <InputFormContainer label="Objetivo:" indentificador="objectives" >
        <Form.Item name="objectives" rules={[{required: true, message: "Por favor ingresa los objetivos"}]}>
          <Select size="large" placeholder="Objetivos">
            <Option value="ventas">Ventas</Option>
          </Select>
        </Form.Item>
      </InputFormContainer>

      <InputFormContainer label="Acciones (basadas en las objetivos):" indentificador="actions">
        <Form.Item name="actions" rules={[{ required: true, message: "Por favor ingrese las Acciones" }]}>
          <Select placeholder="Acciones (basadas en las objetivos):" mode="multiple" size="large">
            <Select.Option value="Contratación" key={1}>Contratación</Select.Option>
            <Select.Option value="Renovación" key={2}>Renovación</Select.Option>
            <Select.Option value="Reserva" key={3}>Reserva</Select.Option>
          </Select>
        </Form.Item>
      </InputFormContainer>

      <InputFormContainer label="Tags o etiquetas asociadas a la campaña:" indentificador="tags">
        <Form.Item name="tags" rules={[{ required: true, message: "Por favor ingrese las Tags o etiquetas" }]}>
          <Select placeholder="Tags o etiquetas asociadas a la campaña:" mode="multiple" size="large">
            <Select.Option value="Contratación" key={1}>Etiqueta 1</Select.Option>
            <Select.Option value="Renovación" key={2}>Etiqueta 2</Select.Option>
            <Select.Option value="Reserva" key={3}>Etiqueta 3</Select.Option>
          </Select>
        </Form.Item>
      </InputFormContainer>

      {
        typeCampaing === 1 && 
        <>
        <FormTitle text="Indica el nivel de servicio: " />

        <InputFormContainer label="Selecciona una opción:" indentificador="nivel" >
          <Form.Item name="nivel" rules={[{required: true, message: "Por favor ingresa el nivel"}]}>
            <Select size="large" placeholder="Objetivos">
              <Option value="nivel_1">Nivel 1</Option>
            </Select>
          </Form.Item>
        </InputFormContainer>
        </>
      }

      {/* <InputFormContainer label="Canales (inbound):" indentificador="channels">
        <Form.Item name="channels" rules={[{ required: true, message: "Por favor ingrese los Canales:" }]} >
          <Select placeholder="Canales (inbound):" mode="multiple" size="large">
            <Select.Option value="Email" key={1}>
              Email
            </Select.Option>
            <Select.Option value="SMS" key={2}>
              SMS
            </Select.Option>
            <Select.Option value="Telefónico" key={3}>
              Telefónico
            </Select.Option>
            <Select.Option value="WebChat" key={4}>
              WebChat
            </Select.Option>
            <Select.Option value="IM" key={5}>
              IM
            </Select.Option>
          </Select>
        </Form.Item>
      </InputFormContainer> */}

      <FormTitle text="Fecha de inicio, finalización y frecuencia: " />
      
      <div className="nd-grid m-grid-2">
        <InputFormContainer label="Fecha de inicio:" indentificador="initDate" >
          <Form.Item name="initDate" rules={[{required: true, message: "Debe indicar la fecha de inicio"}]}>
            <DatePicker size="large" placeholder="Fecha de inicio" onChange={onChange} />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="Hora de inicio:" indentificador="initHour">
          <Form.Item name="initHour" rules={[{required: true, message: "Debe indicar la hora de inicio"}]}>
            <input type="time" placeholder="Hora de inicio"  />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="Fecha de finalización:" indentificador="finalitationDate">
          <Form.Item name="finalitationDate" rules={[{required: true, message: "Debe indicar la fecha de finalización:"}]}>
            <DatePicker size="large" placeholder="Fecha de finalización" onChange={onChange} />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="Hora de finalización:" indentificador="finalitationHour">
          <Form.Item name="finalitationHour" rules={[{required: true, message: "Debe indicar la hora de finalización:"}]}>
            <input type="time" placeholder="Hora de inicio"  />
          </Form.Item>
        </InputFormContainer>

        <div className="m-cols-2">
          <InputFormContainer label="Frecuencia de la campaña:" indentificador="frecuence">
            <Form.Item name="frecuence" rules={[{required: true, message: "Frecuencia de la campaña::"}]}>
              <Select size="large" placeholder="Frecuencia de la campaña:">
                <Option value="Frecuencia de la campaña: ">Repetir diariamente</Option>
              </Select>
            </Form.Item>
          </InputFormContainer>
        </div>

        <FormTitle text="Cantidad de acciones por campaña: " />
        
        <div className="m-cols-2 ">
          <SliderRangeCampaing />
        </div>
        
      </div>

      <div className="buttons-container mt-30">
        <Button content={`${newCampaing ? 'Crear y guardar campaña' : 'Guardar campaña'}!`} type="primary" customClass="s-large m-auto" htmlType="submit" />
      </div>
    </Form>

    <Modal
      isOpenModal={isOpenModalSuccess} 
      iconModal={iconSuccess}
      titleModal={`¡Campaña ${newCampaing ? 'Creada' : 'Editada'}!`}
      closeModal={() => closeModalSuccess()}
      subTitleModal={`${!newCampaing ? 'Tu campaña ha sido editada' : 'Tu campaña ha sido creada, ahora solo debes completar el resto de información para poder lanzarla correctamente.'}`}
      >
      { 
        newCampaing &&
        <div className="buttons-container center mt-20">
          <Button content="Crear otra campaña" type="primary" customClass="s-large m-auto" clickHandler={() => clearForm()} />
          <Button content="Gestionar campáñas" type="primary outline" customClass="s-large m-auto" clickHandler={() => setLocation('/campaigns/gestionar')}/>
        </div>
       }
       {
        !newCampaing &&
        <div className="buttons-container center mt-20">
          <Button content="Gestionar campáñas" type="primary outline" customClass="s-large m-auto" clickHandler={() => setLocation('/campaigns/gestionar')}/>
        </div>
       }
    </Modal> 

    </>
  )
}

export default FormCampaing
